import React from 'react';
import PropTypes from 'prop-types';

import { Nav } from 'react-bootstrap-5';

import { tabs } from './config';

export default function PipelineSettingsTabs({ activeTab, setActiveTab }) {
  return (
    <Nav
      activeKey={activeTab}
      variant="tabs"
      onSelect={setActiveTab}
    >
      {tabs.map(option => (
        <Nav.Item key={option.value}>
          <Nav.Link eventKey={option.value}>{option.label}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
}

PipelineSettingsTabs.propTypes = {
  activeTab: PropTypes.oneOf(tabs.map(option => option.value)).isRequired,
  setActiveTab: PropTypes.func.isRequired,
};
